import { Injectable, Signal, signal } from '@angular/core'

@Injectable({
    providedIn: 'root'
})
export class ErrorService {
    private _error = signal<Error | null>(null)

    public get(): Signal<Error | null> {
        return this._error
    }

    public set(value: Error | null): void {
        this._error.set(value)
    }
}
